module.exports = __webpack_public_path__ + "img/empty-activity.8cd38ba4.svg";